interface LogoProps {
  variant?: 'mark' | 'full';
  className?: string;
  alt?: string;
}

const SOURCES = {
  mark: '/logo.png',
  full: '/logo-full.png',
} as const;

export function Logo({
  variant = 'mark',
  className = '',
  alt = 'Booknest',
}: LogoProps): JSX.Element {
  return (
    <img
      src={SOURCES[variant]}
      alt={alt}
      className={className}
      draggable={false}
    />
  );
}
